export default __webpack_public_path__ + "images/linkedin-ffe3d037a96b65578615429b90068109.svg";